<template>
	<p class="mb-3" v-html="item.description"></p>
	<template v-for="(fieldGroup,fieldTypeIndex) in item.fields">
		<input-unit
				v-if="fieldGroup.type === 'input'"
				v-model="form[fieldGroup.question]"
				:options="{
							slug: `field_${fieldTypeIndex}`,
							name: fieldGroup.question,
							readonly: loading,
							required: true,
						}"
		/>

		<template v-if="fieldGroup.type === 'check'">
			<label>
				{{ fieldGroup.question }}
			</label>
			<template v-for="(answer,index) in fieldGroup.answers">
				<div class="checkbox-unit">
					<input
							type="checkbox"
							class="checkbox-unit__input"
							:id="answer.answer"
							:name="answer.answer"
							v-model="form[fieldGroup.question]"
							:value="answer.answer"
							:disabled="loading"
							required
					>
					<label class="checkbox-unit__label" :for="answer.answer">
						{{ answer.answer }}
					</label>
				</div>
			</template>
		</template>

		<vue-select-unit
				v-if="fieldGroup.type === 'select'"
				v-model="form[fieldGroup.question]"
				:options="{
							slug: `field_${fieldTypeIndex}`,
							name: fieldGroup.question,
							label: 'answer',
							options: fieldGroup.answers.filter(element => element.answer),
							reduceFn: (option) => option.answer,
							disabled: loading,
							required: true
						}"
		/>

		<div class="mt-3">
			<radio-button-unit
					v-if="fieldGroup.type === 'radio'"
					v-model="form[fieldGroup.question]"
					:options="{
								slug: `field_${fieldTypeIndex}`,
								name: fieldGroup.question,
								options: fieldGroup.answers.map((answer,index) => { return {name: answer.answer, value: answer.answer, readonly: loading}}),
								required: true,
							}"
			/>
		</div>
	</template>

	<div class="d-flex justify-content-center">
		<button-unit
				@click-on-btn="sendForm"
				:options="{
							text: translate('send'),
							textColor: 'var(--color-header-text)',
							bgColor: 'var(--color-header-button-bg)',
							shape: ButtonUnitShape.RECTANGLE,
							disabled: loading
						}"
		/>
	</div>
</template>
<script lang="ts">
import {defineComponent, PropType} from 'vue'
import InputUnit from "./Units/InputUnit.vue";
import RadioButtonUnit from "./Units/RadioButtonUnit.vue";
import VueSelectUnit from "./Units/VueSelectUnit.vue";
import ButtonUnit from "./Units/ButtonUnit.vue";
import {ButtonUnitShape} from "./Units/Interfaces/ButtonUnitShape";
import {FormInputInterface} from "../Views/PageView/Interfaces/Components/FormInputInterface";
import Sweetalert2 from "sweetalert2";
import axios from "axios";
import {FormComponentInterface} from "../Views/PageView/Interfaces/Components/FormComponentInterface";

export default defineComponent({
	name: "InlineForm",
	components: {ButtonUnit, VueSelectUnit, RadioButtonUnit, InputUnit},
	props: {
		item: {
			type: Object as PropType<FormComponentInterface>,
			required: true,
		}
	},
	data() {
		return {
			loading: false,
			form: {} as PropType<FormInputInterface>,
		}
	},
	computed: {
		ButtonUnitShape() {
			return ButtonUnitShape;
		}
	},
	mounted() {
		this.resetFormFields();
	},
	methods: {
		resetFormFields(): void {
			this.item.fields.forEach((field: any) => {
				let question = field.question;
				//@ts-ignore
				this.form[question] = field.type === 'check' ? [] : '';
			});
		},
		checkFormLength(): boolean {
			let missingData = false;
			this.item.fields.forEach((field: any) => {
				let question = field.question;
				//@ts-ignore
				if (this.form[question].length === 0) {
					missingData = true;
				}
			});

			return missingData;
		},
		sendForm(): void {

			if (this.checkFormLength()) {
				Sweetalert2.fire(this.translate('miss-form-fields'), this.translate('miss-form-fields'), 'error');
				return;
			}

			this.loading = true;
			axios.post('/api/forms', {answers: {...this.form}, group: this.item.formId, url: window.location.href}).then((response: any) => {
				if (response.status === 200 && response.data.success === true) {
					this.resetFormFields();
					Sweetalert2.fire(this.translate('success-filled'), this.item?.success_message ?? this.translate('success-form-filled'), 'success');
				}
			}).catch((error: any) => {
				console.log(error);
				Sweetalert2.fire(this.translate('ops-error-title'), this.translate('ops-error-text'), 'error');
			}).finally(() => {
				this.loading = false;
			})
		}
	}
})
</script>
<style scoped>

</style>
